import { getEnvironment } from './helpers';

/** GA4 measurement ID for the NKY Connect production property. */
export const GA_MEASUREMENT_ID = 'G-7P17WFC2WQ';

/** Google Analytics runs only on production builds (`REACT_APP_ENVIRONMENT=prd`). */
export function isGoogleAnalyticsEnabled() {
  return getEnvironment() === 'prd';
}

/**
 * Load gtag.js and configure GA4 on PRD only.
 * No-op on local / DEV / UAT.
 */
export function initGoogleAnalytics() {
  if (!isGoogleAnalyticsEnabled() || typeof window === 'undefined') return false;
  if (window.__nkyGaInitialized) return true;

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  // Page views are sent from ScrollToTop (including the first route).
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
  window.__nkyGaInitialized = true;
  return true;
}

/** Record a virtual page view for React Router navigations. */
export function trackGaPageView(path) {
  if (!isGoogleAnalyticsEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: path });
}
